// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28a1Q","close":"styles_close__1GZbv","card":"styles_card__2As87","head":"styles_head__2nz5z","body":"styles_body__2BZsB"};